// src/services/ships/shipsService.js
import axios from '../axiosInstance';
import qs from 'qs';

export async function queryEnabledShips({
    search,
    pageSize,
    cursor,
    sortBy,
    sortDir,
    filterModel,
    signal = null,
} = {}) {
    const body = {
        search: search ?? null,
        pageSize,
        cursor: cursor ?? null,
        sortBy: sortBy ?? 'description',
        sortDir: sortDir ?? 'asc',
        filterModel: filterModel ?? { items: [], logicOperator: 'and' },
    };

    const { data } = await axios.post('/Ships/queryEnabled', body, { signal });
    return data;
}

export async function getShipsEnabled({
    search = '',
    pageSize = 50,
    lastId = null,
    signal = null,
} = {}) {
    const { data } = await axios.get('/Ships/getEnabled', {
        params: { search, pageSize, lastId },
        signal,
    });
    return data;
}

export async function getShipById(id, signal = null) {
    const { data } = await axios.get(`/Ships/${id}`, { signal });
    return data;
}

export async function createShip(payload, signal = null) {
    const { data } = await axios.post('/Ships', payload, { signal });
    return data;
}

export async function updateShip(id, payload, signal = null) {
    await axios.put(`/Ships/${id}`, payload, { signal });
    return true;
}

export async function deleteShip(id, signal = null) {
    const { data } = await axios.delete(`/Ships/${id}`, { signal });
    return data;
}

export async function restoreShip(id, signal = null) {
    await axios.post(`/Ships/${id}/restore`, null, { signal });
    return true;
}

export async function getEnabledShipsByIds(ids, signal = null) {
    if (!ids || ids.length === 0) return [];
    const res = await axios.post(
        '/Ships/byIdsEnabled',
        { filterModel: { items: [], logicOperator: 'and' } },
        {
            params: { ids },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
            signal,
        }
    );
    return res.data;
}
